import Grid from '@mui/material/Grid';
import ExpandableBar from 'components/ExpandableBar';
import LcsFactorySelectorExternalExposure from 'connectedComponents/HeaderButtons/LcsTableFactorySelectorExternalExposure';
import SubstanceSelector from 'connectedComponents/HeaderButtons/SubstanceTableSelector';
import SubstanceShipmentSelector from 'connectedComponents/HeaderButtons/SubstanceShipmentTableSelector';
import ScenarioSelector from 'connectedComponents/HeaderButtons/ScenarioTableSelector';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SpinButton from 'components/Buttons/SpinButton';
import { mixtureSubstancesBySubstance, shipmentsByRawMaterial } from 'selectors/generic';
import theme from 'source/theme';

const Component = props => {
  const {
    currentOptionShipment, currentOptionSubstance, currentOptionLcs,
    currentOptionScenario, mixtureSubstancesBySubstance, rawMaterialsById, scenarios,
    shipmentsByRawMaterial, suppliersById
  } = props;
  const {
    closeScenarioManagement, handleCreateScenarioOpen, onSelectionShipment,
    onSelectionScenario, onSelectionSubstance, onSelectionLcs
  } = props;

  const [update, setUpdate] = useState({});
  useEffect(() =>
    setUpdate({}),
    [ currentOptionShipment, currentOptionSubstance, currentOptionLcs, currentOptionScenario ]
    );

  const optionKeys1 = [
    { title: 'CODIGO_MP', tag: 'raw_material_code' },
    { title: 'MP_NOME', tag: 'raw_material_name' },
  ];

  const optionKeys2 = [
    { title: 'CODIGO', tag: 'code' },
    { title: 'DESIGNAÇÃO COMERCIAL', tag: 'trade_name' },
    { title: 'FORNECEDOR', tag: 'name', nested: 'supplier_id' },
  ];

  const shipments = [];
  (shipmentsByRawMaterial[currentOptionSubstance.id] || []).forEach(shipment =>
    shipments.push({
      ...shipment,
      shipment_substance_id: currentOptionSubstance.id,
      shipment_id_mp: currentOptionSubstance.id,
      raw_material_name: currentOptionSubstance.name,
      raw_material_code: currentOptionSubstance.code,
    })
  );
  (mixtureSubstancesBySubstance[currentOptionSubstance.id] || []).forEach(mix =>
    (shipmentsByRawMaterial[mix.mixture_id] || []).forEach(shipment =>
      shipments.push({
        ...shipment,
        shipment_mixture_id: mix.mixture_id,
        shipment_id_mp: mix.mixture_id,
        raw_material_name: rawMaterialsById[mix.mixture_id].name,
        raw_material_code: rawMaterialsById[mix.mixture_id].code,
      })
    )
  );

  const mp = optionKeys1.map(option => currentOptionShipment[option.tag]).join(' / ');
  // `nested` is supplier_id, which arrives as a number now: the row it used to
  // carry is read out of the suppliers slice.
  const ship = optionKeys2.map(option => option.nested ?
    suppliersById[currentOptionShipment[option.nested]][option.tag] :
    currentOptionShipment[option.tag]
  ).join(' / ');

  const scenarioText = () =>
    <span>
      <span style={{ backgroundColor: theme.palette.primary.main, borderRadius: '5px', paddingTop: 3 }}>&nbsp;SUBSTÂNCIA&nbsp;</span>
      &nbsp;{currentOptionSubstance['name']}&nbsp;
      <span style={{ backgroundColor: theme.palette.primary.main, borderRadius: '5px', paddingTop: 3  }}>&nbsp;MATÉRIA_PRIMA&nbsp;</span>
      &nbsp;{mp}&nbsp;
      <span style={{ backgroundColor: theme.palette.primary.main, borderRadius: '5px', paddingTop: 3  }}>&nbsp;FORNECIMENTO&nbsp;</span>
      &nbsp;{ship}&nbsp;
      <span style={{ backgroundColor: theme.palette.primary.main, borderRadius: '5px', paddingTop: 3  }}>&nbsp;LCS&nbsp; </span>
      &nbsp;{currentOptionLcs['description']}&nbsp;
      <span style={{ backgroundColor: theme.palette.primary.main, borderRadius: '5px', paddingTop: 3  }}>&nbsp;CENÁRIO&nbsp;</span>
      &nbsp;{currentOptionScenario && currentOptionScenario['code']}&nbsp;
    </span>;

  return (
    <ExpandableBar
      header=''
      text={scenarioText}
      update={update}
      goBack={closeScenarioManagement}
    >
      <Grid container>
        <Grid size={12} style={{ marginBottom: 5 }}>
          <SubstanceSelector
            currentOption={currentOptionSubstance}
            onSelection={onSelectionSubstance}
          />
        </Grid>
        <Grid size={12} style={{ marginBottom: 5 }}>
          <SubstanceShipmentSelector
            currentOption={currentOptionShipment}
            onSelection={onSelectionShipment}
            substance={currentOptionSubstance}
          />
        </Grid>
        <Grid size={12} style={{ marginBottom: 5 }}>
          <LcsFactorySelectorExternalExposure
            currentOptionShipment={currentOptionShipment}
            currentOption={currentOptionLcs}
            onSelection={onSelectionLcs}
          />
        </Grid>
        <Grid size={12} style={{ marginBottom: 5 }}>
          <ScenarioSelector
            currentOption={currentOptionScenario}
            onSelection={onSelectionScenario}
            options={scenarios}
          />
        </Grid>
        <Grid size={12}>
          <SpinButton
            label='Criar novo cenário'
            onClick={handleCreateScenarioOpen}
          />
        </Grid>
      </Grid>
    </ExpandableBar>
  );
};

const mapStateToProps = (state, props) => ({
  mixtureSubstancesBySubstance: mixtureSubstancesBySubstance(state),
  rawMaterialsById: state.rawMaterials.models,
  shipmentsByRawMaterial: shipmentsByRawMaterial(state),
  suppliersById: state.suppliers.models,
});

export default connect(mapStateToProps)(Component);
